/*
 * @Author: Json Chen
 * @Date: 2021-07-27 10:43:48
 * @LastEditTime: 2021-07-27 17:06:17
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Localisation/Components/AddressFormatModalForm.tsx
 */

import { Checkbox, Form, Input } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';

import {
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { checkboxOptions } from '../config';
import styles from '../style.module.less';

const CheckboxGroup = ({ value = [], onChange }: any): any => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const list = checkboxOptions({ getI18n }).filter((item) => item.checkedable);

  const onCheckChange = (checked, item) => {
    const checkedIndex = value.findIndex((v) => v.fieldType === item.fieldType);
    if (checkedIndex > -1) {
      onChange(value.filter((_, i) => i !== checkedIndex));
    } else {
      onChange(
        value.concat({
          fieldType: item.fieldType,
          fieldName: item.fieldName,
        }),
      );
    }
  };

  useEffect(() => {
    const uncheckedableOptions = checkboxOptions({ getI18n }).filter(
      (item) => !item.checkedable,
    );

    if (
      !uncheckedableOptions.every((u) =>
        value.find((v) => v.fieldType === u.fieldType),
      )
    ) {
      onChange(
        value.concat(
          uncheckedableOptions.map((item) => ({
            fieldType: item.fieldType,
            fieldName: item.fieldName,
          })),
        ),
      );
    }
  }, [value]);

  return list.map((item, index) => {
    const sameItem = value.find((v) => v.fieldType === item.fieldType);

    return (
      <Checkbox
        key={index}
        checked={!!sameItem}
        onChange={(e) => onCheckChange(e.target.checked, item)}>
        {item.addressField}
      </Checkbox>
    );
  });
};

const AddressFormatModalForm = ({
  onCancel,
  onModalConfirm,
  existList,
  editIndex,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const [confirmDisable, setConfirmDisable] = useState<boolean>(false);

  const onOk = () => {
    form.validateFields().then((res) => {
      onModalConfirm(res, editIndex);
      _onCancel();
    });
  };

  const _onCancel = () => {
    form.resetFields();
    onCancel();
  };

  const initVal = useMemo(() => {
    if (editIndex || editIndex === 0) {
      return existList[editIndex];
    }
    return {
      name: `Format ${existList.filter((item) => item.customized).length + 1}`,
      fields: [],
    };
  }, [editIndex]);
  return (
    <React.Fragment>
      <Form
        name={'AddressFormatModalForm'}
        form={form}
        colon={false}
        layout={'vertical'}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 24,
        }}
        className={styles.editForm}>
        <ModalContent>
          <Section style={{ paddingTop: 0 }}>
            <Form.Item
              name={'name'}
              initialValue={initVal.name}
              label={
                <div>{getI18n('storeLocalisation.component.fieldName')}</div>
              }
              rules={[
                {
                  required: true,
                  message: replaceI18nVariables(
                    getI18n('general.fieldisrequired'),
                    getI18n('storeLocalisation.component.fieldName'),
                  ),
                },
                {
                  validator(_, value) {
                    const nameExist = !!existList.find((e, index) => {
                      if (index === editIndex) {
                        // name 可以和自己重复
                        return false;
                      }
                      return e.name.trim() === value.trim();
                    });
                    if (nameExist) {
                      setConfirmDisable(true);
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'storeLocalisation.component.addressFieldErrorValid',
                          ),
                        ),
                      );
                    }
                    setConfirmDisable(false);

                    return Promise.resolve();
                  },
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              name={'fields'}
              initialValue={initVal.fields}
              label={
                <div>
                  {getI18n(
                    'storeLocalisation.component.additionalAddressField',
                  )}
                </div>
              }>
              <CheckboxGroup existList={existList} />
            </Form.Item>
          </Section>
        </ModalContent>
      </Form>
      <ModalFooter
        okText={getI18n('general.confirm')}
        onCancel={_onCancel}
        onOk={onOk}
        hideOkButton={confirmDisable}
      />
    </React.Fragment>
  );
};

export default AddressFormatModalForm;
